import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter } from 'modules/performance_process/components/review/show/Filters/context'

export const EvaluationsStatusFilter = () => {
  const { value, setValue } = useFilter('evaluationsStatus')

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.reviews.target_datatable.results.filter.title')}
      value={value}
      options={[
        {
          label: i18n.t('performance_process.reviews.target_datatable.results.pending'),
          value: 'pending',
        },
        {
          label: i18n.t('performance_process.reviews.target_datatable.results.published'),
          value: 'published',
        },
      ]}
      onValueChange={setValue}
    />
  )
}
